'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_navigation_Button_BaseButton = require('../Button/BaseButton.cjs.js');

function BaseIconButton(_a) {
  var { icon, isCircle, label, shouldCorrectTooltipPosition, tooltipId, tooltipPosition } = _a, buttonProps = tslib_es6.__rest(_a, ["icon", "isCircle", "label", "shouldCorrectTooltipPosition", "tooltipId", "tooltipPosition"]);
  return react.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { content: label, position: tooltipPosition, shouldCorrectPosition: shouldCorrectTooltipPosition, showTooltipOnTouchDevices: false, tooltipId }, ({ childProps }) => react.jsx(
    components_navigation_Button_BaseButton.BaseButton,
    Object.assign({ "aria-label": label }, buttonProps, childProps, { isPill: isCircle, isSquare: true }),
    react.jsx(components_display_Icon_Icon.Icon, { canAcceptPointerEvents: false, isBlock: true, name: icon })
  ));
}

exports.BaseIconButton = BaseIconButton;
//# sourceMappingURL=BaseIconButton.cjs.js.map
